import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

export const PageNotFound = () => {
  const { t } = useTranslation()
  return (
    <main className="grid h-full flex-auto place-items-center bg-surface px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="font-semibold text-accent">404</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight sm:text-5xl">
          {t('pages.notFound')}
        </h1>
        <p className="mt-6 leading-7">{t('pages.pageNotFoundDetail')}</p>
        <div className="mt-10 gap-x-6">
          <Link
            to={`/log-in`}
            className="rounded-md bg-accent px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          >
            {t('pages.goBackToLogin')}
          </Link>
        </div>
      </div>
    </main>
  )
}
